<div class="row">
  <div class="col-12 mt-5 movieTemplate">
    <div class="paneles">
      <div class="row">
        <div class="col-12 px-xl-5">
          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Qué es +Cinemateca?</div>

              <p class="texto">
                Es una plataforma digital que permite a través de internet ver Videos a Demanda. En nuestro catálogo se
                podrán encontrar
                películas, material de archivo, charlas, entrevistas y cortometrajes con el estilo de la programación de
                Cinemateca.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Se puede ingresar desde cualquier parte del mundo?</div>

              <p class="texto">El acceso al catálogo y los comentarios sobre las películas está disponible para todo el
                mundo, el visionado de las
                películas es exclusivamente para el territorio uruguayo.</p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">
                ¿Las películas que aparecen en +Cinemateca son las mismas que se exhiben en la sala?
              </div>

              <p class="texto">
                No, la programación de +Cinemateca es independiente de la programación de las salas debido a que los
                derechos de
                exhibición se manejan de manera independiente en una y otra ventana de exhibición. Sin embargo, varias
                de las películas
                que pasan por nuestras salas luego ingresan al catálogo de VOD.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Qué tipo de películas podemos encontrar?</div>

              <p class="texto">
                El tipo de cine que usualmente programa Cinemateca Uruguaya. Una programación variada y de orígenes
                diversos, con una mirada independiente y de valores artísticos y humanos.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿A cuántas películas podemos acceder?</div>

              <p class="texto">
                El catálogo básico de más de 400 películas, se renovará mes a mes. La plataforma estrenará
                periódicamente nuevos títulos y a su vez alojará muestras, retrospectivas y festivales de cine
                nacionales e internacionales.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cómo funciona la plataforma?</div>

              <p class="texto">
                Un usuario debe registrarse con sus datos para poder ver el contenido de +Cinemateca. Luego de realizado
                este procedimiento puede elegir entre dos modalidades de visualización Pay Per View (PPV) y/o
                Membrecías.
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <h4 class="my-4 font-weight-bold text-light">MODALIDAD PAY PER VIEW</h4>
              </div>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cuál es el costo de visionado por película?</div>

              <p class="texto">Cada película se habilitará mediante el pago de $115 (ciento quince pesos uruguayos)</p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cuántas veces puedo ver la misma película si la compro en formato PPV?</div>

              <p class="texto">La podés ver todas las veces que quieras en un plazo de 48 horas.</p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Con qué medios de pago puedo abonar?</div>

              <p class="texto">
                Con tarjetas de débito y crédito VISA; con tarjetas de crédito OCA, Mastercard, Cabal, Creditel y
                Créditos Directos.
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <h4 class="my-4 font-weight-bold text-light">MODALIDAD MEMBRESÍA +CINEMATECA</h4>
              </div>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Qué beneficios tiene ser miembro de +Cinemateca?</div>

              <p class="texto">
                Pueden ver todo el contenido pagando mensualmente $360 (durante al menos 3 meses) o también pueden hacer
                un pago único
                por año de $3.600.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Puedo hacerme miembro un mes y luego borrarme?</div>

              <p class="texto">
                No, para ser miembro de +Cinemateca debes aceptar los Términos y Condiciones en donde se establece que
                el mínimo para ser miembro son 3 meses.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cómo se paga la mensualidad?</div>

              <p class="texto">
                Se debita de tu tarjeta de crédito VISA, OCA, Cabal, Creditel o Créditos Directos. No está incluido en
                esta modalidad la tarjeta Mastercard.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cuál es la duración de una membresía?</div>

              <p class="texto">Se extiende desde el día que la contratas hasta el mismo día del mes siguiente.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <h4 class="my-4 font-weight-bold text-light">SOCIOS de CINEMATECA</h4>
              </div>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Qué beneficios tienen los Socios de Cinemateca?</div>

              <p class="texto">
                Los Socios podrán ver hasta 12 películas por mes sin costo.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">No me alcanza, quiero ver más que esas películas seleccionadas.</div>

              <p class="texto">
                Los socios de Cinemateca tienen la posibilidad de pagar un adicional $200 por mes que les permite ver el
                contenido de
                forma ilimitada.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cómo sabe +Cinemateca que soy socio de Cinemateca?</div>

              <p class="texto">
                El sistema de socios está integrado, para obtener los beneficios debe tener su cuota al día y tener el
                mismo usuario
                (mail) que utiliza en Cinemateca.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cómo hago para adquirir el paquete adicional?</div>

              <p class="texto">
                En la parte superior izquierda de la plataforma encontrarás un botón para adquirirlo. El mismo se pagará
                a través de tu tarjeta de crédito VISA, OCA, Cabal, Creditel o Créditos Directos.
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <h4 class="my-4 font-weight-bold text-light">OTRAS CONSULTAS</h4>
              </div>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Cuáles son los requisitos técnicos para poder acceder a los contenidos de
                +Cinemateca?</div>

              <p class="texto">
                Se puede acceder a los contenidos desde computadoras (Windows, MAC, Linux) o dispositivos móviles
                (Android o IOS). La
                configuración del player ajusta el bitrates de los videos de acuerdo a las características del
                dispositivos y la
                velocidad de internet al momento de reproducir (entre 600, 1200, 2500 bitrates). La velocidad de
                conexión mínima
                recomendada es de 15 mps.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Puedo verlo en mi SmartTV?</div>

              <p class="texto">
                Sí, puedes castear tu película desde el navegador Google Chrome de tu PC o Laptop a un TV con
                Chromecast, Roku o Apple
                TV. También a SmartTv que trabajen con el sistema AndroidTV Google Certified (B&O, Hisense, Haier, Iris,
                Philips. LeEco,
                Sharp, Sony, TCL, Toshiba, Grundig y Beko).
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿También puedo hacerlo desde mi smartphone?</div>

              <p class="texto">
                Sí, pero es recomendable que para eso te descargues nuestra App, actualmente solo disponible para
                Android.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿En qué calidad podré ver las películas?</div>

              <p class="texto">
                La calidad máxima en la que podrás ver las películas es HD y puede variar según tu conexión a internet.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Todas las películas de la plataforma están subtituladas?</div>

              <p class="texto">
                No. En el caso de las películas habladas en castellano, sólo algunas tendrán subtítulos en inglés. En el
                caso de los
                films hablados en otro idioma distinto al castellano, tendrán la opción de activar los subtítulos en
                castellano. De
                acuerdo a la demanda, veremos si es necesario agregar subtítulos en otros idiomas.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Puedo comentar y repasar las películas que vi en la plataforma?</div>

              <p class="texto">
                Sí, existe una sección denominada Reconecta que permite al usuario comentar y leer comentarios de otros
                usuarios sobre
                otras películas.
              </p>
            </div>
          </div>

          <div class="card text-white mb-4">
            <div class="card-body">
              <div class="titulo">¿Qué es Sala de Prensa?</div>

              <p class="texto">
                Es una sala virtual exclusiva para Críticos de Cine, donde pueden acceder a contenidos que les permite
                realizar sus
                reseñas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>